import { DiscountService, type IDiscountService } from "./Discount";
import { type ITabService, TabService } from "./Tabs";
import { type IVoucherService, VoucherService } from "./Vouchers";

export interface IOldRedeemablesService {
  discount: IDiscountService;
  tab: ITabService;
  voucher: IVoucherService;
}

export class OldRedeemablesService implements IOldRedeemablesService {
  discount: IDiscountService;
  tab: ITabService;
  voucher: IVoucherService;

  constructor(api) {
    this.discount = new DiscountService(api);
    this.tab = new TabService(api);
    this.voucher = new VoucherService(api);
  }
}
